import { AudioTrack } from "../shared/audio-track/audio-track.component";
import { UserReview } from "../shared/user-review/user-review.component";

export interface RiveAnimationConfig {
  fileName: string;
  animations: string[];
  ratio: number;
  backgroundImagePath?: string;
  marginTop?: string; //TODO: this is workaround because some animations have redundant space on top
}

export interface QuizOption {
    title?: string;
    subtitle?: string;
    emoji?: string;
    imageMode?: 'top' | 'right' | 'background' | 'top-large';
    imageFilePath?: string;
    rive?: RiveAnimationConfig;
}

export interface Quiz {
    title: string;
    subtitle?: string;
    options?: QuizOption[];
    isTilesDisplay?: boolean; //in case we want to show options as tiles
    isChips?: boolean;
    imageFilePath?: string;
    fullScreenImageFilePath?: string;
    rive?: RiveAnimationConfig;
    videoFilePath?: string;
    headline?: string;
    isNegative?: boolean; //this is just for headline as of now
    topIcon?: string;
    audioTracks?: AudioTrack[];
    isVoting?: boolean;
    hasSocialProof?: boolean; //it should be either social proof or review not both
    userReview?: UserReview;
    isMultiple: boolean;
    isRequired: boolean;
}

export const highlightText = (text: string, isRed: boolean = false) => {
  const className = isRed ? 'red-color' : 'main-color';

  return `<span class="${className}">${text}</span>`;
}

export const quizSteps = {
  duration: {
    title: 'How long do you usually prefer your sensual audio sessions?',
    isTilesDisplay: false,
    options: [
      {
        title: 'Short & Impactful',
        subtitle: `5-10 minutes`,
        imageMode: 'right',
        imageFilePath: 'assets/femtasy/lips.webp',
      },
      {
        title: 'Moderately Long',
        subtitle: `10-20 minutes`,
        imageMode: 'right',
        imageFilePath: 'assets/femtasy/ropes.webp',
      },
      {
        title: 'Long & Immersive',
        subtitle: `20+ minutes`,
        imageMode: 'right',
        imageFilePath: 'assets/femtasy/hand.webp',
      },
    ],
    isMultiple: true,
    isRequired: true,
  } as Quiz,

  pov: {
    title: 'Do you have a preference for the storytelling style?',
    options: [
      { title: 'First-person (I/me) perspective' },
      { title: 'Third-person narrative' },
      { title: 'Multiple character voices' },
      { title: 'No preference' },
    ],
    isMultiple: false,
    isRequired: true,
  } as Quiz,

  intensity: {
    title: `How intense do you like your audio experiences to be?`,
    options: [
      { title: 'Gentle and caring, with a soft touch' },
      { title: 'Sensual and romantic, somewhere in the middle' },
      { title: 'Bold and intense, with strong emotions' },
      { title: 'Wild and provocative, pushing the boundaries' },
    ],
    isMultiple: false,
    isRequired: true,
  } as Quiz,

  experience: {
    title: 'What would you like to experience?',
    subtitle: `Pick as many as you like`,
    isTilesDisplay: true,
    options: [
      {
        title: 'Woman & Man',
        imageMode: 'top',
        imageFilePath: 'assets/category/femalemale.png',
      },
      {
        title: 'Woman & Woman',
        imageMode: 'top',
        imageFilePath: 'assets/category/femalefemale.png',
      },
      {
        title: 'Man & Man',
        imageMode: 'top',
        imageFilePath: 'assets/category/malemale.png',
      },
      {
        title: 'Non-Binary',
        imageMode: 'top',
        imageFilePath: 'assets/category/nonbinary.png',
      },
    ],
    isMultiple: true,
    isRequired: true,
  } as Quiz,

  kinks: {
    title: 'Pick up the kinks which turn you on',
    isTilesDisplay: true,
    options: [
      {
        title: 'Public Sex',
        imageMode: 'background',
        imageFilePath: 'assets/subcategory/publicsex.jpg',
      },
      {
        title: 'Cosy at home',
        imageMode: 'background',
        imageFilePath: 'assets/subcategory/cosyathome.jpg',
      },
      {
        title: 'With stranger',
        imageMode: 'background',
        imageFilePath: 'assets/subcategory/withstranger.jpg',
      },
      {
        title: 'Authority',
        imageMode: 'background',
        imageFilePath: 'assets/subcategory/authority.jpg',
      },
      {
        title: 'BDSM',
        imageMode: 'background',
        imageFilePath: 'assets/subcategory/bdsm.jpg',
      },
      {
        title: 'Roleplay',
        imageMode: 'background',
        imageFilePath: 'assets/subcategory/roleplay.jpg',
      },
      {
        title: 'Quickie',
        imageMode: 'background',
        imageFilePath: 'assets/subcategory/quickie.jpg',
      },
      {
        title: 'Threesome and more',
        imageMode: 'background',
        imageFilePath: 'assets/subcategory/threesome.jpg',
      },
      {
        title: 'Anal',
        imageMode: 'background',
        imageFilePath: 'assets/subcategory/anal.jpg',
      },
      {
        title: 'Oral',
        imageMode: 'background',
        imageFilePath: 'assets/subcategory/oral.jpg',
      },
      {
        title: 'Toys',
        imageMode: 'background',
        imageFilePath: 'assets/subcategory/toys.jpg',
      },
      {
        title: 'Infidelity',
        imageMode: 'background',
        imageFilePath: 'assets/subcategory/infidelity.jpg',
      },
      {
        title: 'In nature',
        imageMode: 'background',
        imageFilePath: 'assets/subcategory/innature.jpg',
      },
      {
        title: 'Playing Cliches',
        imageMode: 'background',
        imageFilePath: 'assets/subcategory/playingcliches.jpg',
      },
      {
        title: 'Office',
        imageMode: 'background',
        imageFilePath: 'assets/subcategory/office.jpg',
      },
    ],
    isMultiple: true,
    isRequired: true,
  } as Quiz,

    age: {
      title: 'What is your age?',
      subtitle: 'This will help us tailor the experience',
      options: [
        {
          title: '< 21',
        }, {
          title: '21-34',
        }, {
          title: '35-44',
        }, {
          title: '45+',
        },
      ] as QuizOption[],
      isTilesDisplay: true,
      isMultiple: false,
      isRequired: true,
    },
    
    amountInfo: {
      title: 'Join Over 600K Women Your Age Worldwide',
      hasSocialProof: true,
      rive: {
        fileName: 'map',
        animations: ['appear', 'female'], //["idle","female","both","male","appear"]
        ratio: 1.75 / 1,
        backgroundImagePath: 'assets/map.png',
      },
      isRequired: false,
      isMultiple: false,
    } as Quiz,

    relationshipStatus: {
      title: 'Your relationship status',
      options: [
        '💓 Single',
        '🤯 It’s complicated',
       '💍 Engaged',
        '👰‍♀ Married',
        '💔 Divorced',
        '💃 Casually dating',
      ].map(title => ({ title })),
      isMultiple: false,
      isRequired: true,
    },

    orgasms: {
      title: 'What’s the maximum number of orgasms you’ve experienced in one intimate session?',
      options: [
        'None yet, but I’m hopeful',
        '1',
        '2–3',
        '4+',
        'It varies a lot, depending on the experience',
      ].map(title => ({ title })),
      isMultiple: false,
      isRequired: true,
    },

    fantasiesFulfillment: {
      title: 'Do you find it challenging to fulfill your erotic fantasies?',
      //subtitle: '',
      options: [
        '⚖️ Yes, it’s a constant struggle',
        '🏃 Yes, quite often',
        '🤷 Sometimes',
        '😊 Not really',
        '💪 No, I manage well',
      ].map(title => ({ title })),
      isMultiple: false,
      isRequired: true,
    },

    fantasies: {
      title: 'Have you ever fantasized about these scenarios?',
      subtitle: 'Pick as many as you like',
      isTilesDisplay: true,
      options: [
        {
          title: 'Being with two or more partners',
          imageMode: 'background',
          imageFilePath: 'assets/fantasies/threesome.webp',
        },
        {
          title: 'An encounter with a mystical creature',
          imageMode: 'background',
          imageFilePath: 'assets/fantasies/wolf.jpg',
        },
        {
          title: 'Roleplay as someone completely different',
          imageMode: 'background',
          imageFilePath: 'assets/fantasies/roleplay.jpg',
        },
        {
          title: 'A forbidden affair',
          imageMode: 'background',
          imageFilePath: 'assets/fantasies/affair.jpeg',
        },
      ],
      isMultiple: true,
      isRequired: true,
    } as Quiz,

    anxiety: {
      title: `Do you experience ${highlightText('stress or anxiety', true)} related to your personal life and sexual satisfaction?`,
      options: [
        '😰 Yes, it’s significant',
        '😟 Yes, to some extent',
        '😬 Occasionally',
        '🙂 Rarely',
        '😌 Never',
      ].map(title => ({ title })),
      isMultiple: false,
      isRequired: true,
    },

    socialProof: {
      title: `Women’s Healthy Pleasure`,
      subtitle: `<strong>Masturbation is proven to reduce stress and boost well-being</strong><br/><br/> According to research by Women’s Health, 87% of women feel more relaxed and less anxious after self-pleasure. It’s a natural way to release endorphins and improve your mood.`,
      imageFilePath: 'assets/womens_health.jpeg',
      isMultiple: false,
      isRequired: false,
    } as Quiz,

    medicalFact: {
      title: `Medical Fact`,
      subtitle: `A latest <strong>study by Harvard University</strong> shows that listening to sensual audio activates the brain’s <strong>prefrontal cortex</strong> and <strong>visual association areas</strong>, enhancing imagination and visualization. This stimulation increases dopamine by up to <strong>40%</strong>, reduces stress hormones like cortisol, and promotes emotional balance and relaxation.`,
      fullScreenImageFilePath: 'assets/relaxed_girl.jpg',
      isMultiple: false,
      isRequired: false,
    } as Quiz,

    audioInfo: {
      title: `Magic of Audio`,
      subtitle: `We know that Porn industry is mostly tailored for men's needs. That's why we created this audio product tailored for women!`,
      fullScreenImageFilePath: 'assets/woman_bed.jpg',
      isMultiple: false,
      isRequired: false,
    } as Quiz,

    imagination: {
      title: `What does this image make you think of first?`,
      isTilesDisplay: true,
      options: [
        'The touch of warm skin',
        'A secret moment shared',
        'A bold, passionate encounter',
        'Something mysterious and forbidden',
      ].map(title => ({ title })),
      fullScreenImageFilePath: 'assets/fantasies/silhouettes.webp',
      isMultiple: false,
      isRequired: true,
    } as Quiz,

    storiesSample1: {
      title: 'Sexy Audio Stories for Electrifying Fantasies',
      subtitle: 'Do you like how this story sounds?',
      audioTracks: [],
      isVoting: true,
      isMultiple: false,
      isRequired: false,
    } as Quiz,
    
    storiesSample2: {
      title: 'Sexy Audio Stories for Electrifying Fantasies',
      subtitle: 'Does this story spark your imagination?',
      audioTracks: [],
      isVoting: true,
      isMultiple: false,
      isRequired: false,
    } as Quiz,
    
    soundsSample1: {
      title: 'Real Sex Sounds for Raw Pleasure',
      subtitle: 'Do these sounds turn you on?',
      audioTracks: [],
      isVoting: true,
      isMultiple: false,
      isRequired: false,
    } as Quiz,
    
    soundsSample2: {
      title: 'Real Sex Sounds for Raw Pleasure',
      subtitle: 'Does this sound feel real to you?',
      audioTracks: [],
      isVoting: true,
      isMultiple: false,
      isRequired: false,
    } as Quiz,

    honest: {
      title: `Thanks for being honest!`,
      subtitle: `You are doing great! There are only few steps left`,
      rive: {
        fileName: 'hearts',
        animations: ['Hearts'],
        ratio: 1.75 / 1,
      },
      isMultiple: false,
      isRequired: false,
    },

    result: {
      title: `The quiz is done. Cheers! 👍`,
      subtitle: 'Now it’s time to take the next leap. As a special thank you, we’re offering you an exclusive deal to help you reach your goals even faster.',
      rive: {
        fileName: 'impressed',
        animations: ['char', 'skirt', 'birds', 'wings'],
        ratio: 1.75,
      },
      isMultiple: false,
      isRequired: false,
    },
};

